// The one-click fix under an "email address, not a link" error: switch the
// destination picker to Email, so the code opens a new email to that address.
// The creator chooses it; nothing converts silently.
// See docs/plans/2026-09-30-mailto-destinations.plan.md.
export default function MailtoSuggestion({ suggestion, onApply }) {
  if (!suggestion) return null
  return (
    <>
      {" "}
      <button
        type="button"
        onClick={() => onApply(suggestion)}
        className="underline font-medium hover:no-underline focus:outline-none focus:ring-2 focus:ring-voltage focus:ring-offset-2 rounded-sm"
      >
        Make it an Email code instead
      </button>
    </>
  )
}
